/**
 *= require_self
 */

/**
 * Appends notifications to selected target with selected style.
 *
 * @param    array         notifications   array of notifications strings
 * @param    string        id              unique id to allow multiple notifications on same page
 * @param    DOM element   $target          element where to append notifications
 * @param    string        style           'error'
 *
 * @return   {[type]}   [description]
 *
 * @author Gašper Noč <gasper@easistent.com>
 */
function showNotifications(notifications, id, $target, style, config) {
    //if notifications is not array, just return
    if (!$.isArray(notifications)) {
        return false;
    }

    var element;
    var notificationsId = "notifications-" + id;

    // Config
    config = config !== undefined ? config : {};

    //default style
    style = style || "error";

    if (style === "error") {
        style = "danger";
    }

    //transform notifications to single string
    element = '<div id="' + notificationsId + '" class="alert alert-' + style + ' notification"><div>' + notifications.join("</div><div>") + "</div></div>";

    //remove posible duplicate
    $('#' + notificationsId).remove();

    //append notifications to selected element
    $target.append(element);

    // scroll to notification
    if (config.scrollTo) {
        config.scrollTo($target);
    } else {
        $('html,body').animate({
            scrollTop: $target.offset().top - 50
        }, 1000);
    }
}

/**
 * Removes all notifications from view.
 *
 * @author Gašper Noč <gasper@easistent.com>
 */
function removeNotifications() {
    $('.notification').remove();
}

/**
 * Sends a simple instruction to the server,
 * doesn't need response and error checking
 *
 * @author Blaž Pečnik <blaz@easistent.com>
 */
$('.js-mark-notification-as-read').click(function(e) {
    var $btn = $(this);
    var notification_id = $btn.data('notification-id');

    $.ajax({
        cache: false,
        type: 'POST',
        url: 'notifications/mark_as_read',
        data: {
            notification_id: notification_id
        },
        timeout: 10000,
        dataType: 'json',
    });
});
